// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Result_header__xDPJx {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-bottom: 15px;
  border-bottom: 1px solid #cfcfcf;
  padding-bottom: 15px;
  gap: 30%;
}

.Result_title__VUt3y {
  color: var(--darkGray);
  font-family: BebasNeue;
  font-weight: 700;
  font-size: 20px;
}

.Result_label__OqRTw {
  font-weight: 500;
  color: var(--darkGray);
  font-size: 12px;
}

.Result_item__RtSRw {
  display: flex;
  align-items: baseline;
  gap: 20px;
}

.Result_result__VlGWc {
  font-family: Roboto;
  font-size: 16px;
  font-weight: 500;
}

.Result_active__mW6W6 {
  color: var(--orange);
  font-family: Roboto;
  font-size: 16px;
  font-weight: 500;
}

.Result_finished__1AtMn {
  color: var(--darkGray);
  font-family: Roboto;
  font-size: 16px;
  font-weight: 500;
}

.Result_divider__Oe0\\+c {
  width: 100%;
  height: 2px;
  gap: 0px;
  border: 1px;
  border: 1px solid #CFCFCF;
}

.Result_input__n9Lar,
.Result_input__n9Lar .ant-select-selector {
  background-color: #fbfbfb !important;
  border-color: #d2d2d2 !important;
  border-radius: 4px !important;
  width: 100%;
}

.Result_starts__d6xOq {
  display: flex;
  gap: 5px;
}

.Result_containerElipse__AADL1{
  display: flex;
  flex-direction: column;
  gap:5px;
  align-items: center;
}

.Result_elipse__LqVkl {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 90px;
  height: 90px;
  border-radius: 100px;
  border: 1px solid var(--orange);
}

.Result_elipse__LqVkl p {
  font-family: Roboto;
  font-size: 36px;
  font-weight: 500;
  color: var(--orange);
  margin: 0px;
}

`, "",{"version":3,"sources":["webpack://./src/pages/ratings/styles/Result.module.css"],"names":[],"mappings":"AAAA;EACI,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,gCAAgC;EAChC,oBAAoB;EACpB,QAAQ;AACZ;;AAEA;EACI,sBAAsB;EACtB,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;AACnB;;AAEA;EACI,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;AACnB;;AAEA;EACI,aAAa;EACb,qBAAqB;EACrB,SAAS;AACb;;AAEA;EACI,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AACpB;;AAEA;EACI,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AACpB;;AAEA;EACI,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AACpB;;AAEA;EACI,WAAW;EACX,WAAW;EACX,QAAQ;EACR,WAAW;EACX,yBAAyB;AAC7B;;AAEA;;EAEI,oCAAoC;EACpC,gCAAgC;EAChC,6BAA6B;EAC7B,WAAW;AACf;;AAGA;EACI,aAAa;EACb,QAAQ;AACZ;;AACA;EACI,aAAa;EACb,sBAAsB;EACtB,OAAO;EACP,mBAAmB;AACvB;;AACA;EACI,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,+BAA+B;AACnC;;AAEA;EACI,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,WAAW;AACf","sourcesContent":[".header {\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    margin-bottom: 15px;\n    border-bottom: 1px solid #cfcfcf;\n    padding-bottom: 15px;\n    gap: 30%;\n}\n\n.title {\n    color: var(--darkGray);\n    font-family: BebasNeue;\n    font-weight: 700;\n    font-size: 20px;\n}\n\n.label {\n    font-weight: 500;\n    color: var(--darkGray);\n    font-size: 12px;\n}\n\n.item {\n    display: flex;\n    align-items: baseline;\n    gap: 20px;\n}\n\n.result {\n    font-family: Roboto;\n    font-size: 16px;\n    font-weight: 500;\n}\n\n.active {\n    color: var(--orange);\n    font-family: Roboto;\n    font-size: 16px;\n    font-weight: 500;\n}\n\n.finished {\n    color: var(--darkGray);\n    font-family: Roboto;\n    font-size: 16px;\n    font-weight: 500;\n}\n\n.divider {\n    width: 100%;\n    height: 2px;\n    gap: 0px;\n    border: 1px;\n    border: 1px solid #CFCFCF;\n}\n\n.input,\n.input :global(.ant-select-selector) {\n    background-color: #fbfbfb !important;\n    border-color: #d2d2d2 !important;\n    border-radius: 4px !important;\n    width: 100%;\n}\n\n\n.starts {\n    display: flex;\n    gap: 5px;\n}\n.containerElipse{\n    display: flex;\n    flex-direction: column;\n    gap:5px;\n    align-items: center;\n}\n.elipse {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 90px;\n    height: 90px;\n    border-radius: 100px;\n    border: 1px solid var(--orange);\n}\n\n.elipse p {\n    font-family: Roboto;\n    font-size: 36px;\n    font-weight: 500;\n    color: var(--orange);\n    margin: 0px;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `Result_header__xDPJx`,
	"title": `Result_title__VUt3y`,
	"label": `Result_label__OqRTw`,
	"item": `Result_item__RtSRw`,
	"result": `Result_result__VlGWc`,
	"active": `Result_active__mW6W6`,
	"finished": `Result_finished__1AtMn`,
	"divider": `Result_divider__Oe0+c`,
	"input": `Result_input__n9Lar`,
	"starts": `Result_starts__d6xOq`,
	"containerElipse": `Result_containerElipse__AADL1`,
	"elipse": `Result_elipse__LqVkl`
};
export default ___CSS_LOADER_EXPORT___;
